/* ============================================
   AUTOROULIO ACCESSORIES - THEME JS
   ============================================ */

document.addEventListener('DOMContentLoaded', function () {

  /* ============================================
     CART DRAWER
     ============================================ */
  const cartDrawer = document.getElementById('cart-drawer');
  const cartOverlay = document.getElementById('cart-overlay');
  const cartOpenBtns = document.querySelectorAll('[data-cart-open]');
  const cartCloseBtns = document.querySelectorAll('[data-cart-close]');

  function openCart() {
    if (cartDrawer) cartDrawer.classList.add('active');
    if (cartOverlay) cartOverlay.classList.add('active');
    document.body.style.overflow = 'hidden';
  }
  function closeCart() {
    if (cartDrawer) cartDrawer.classList.remove('active');
    if (cartOverlay) cartOverlay.classList.remove('active');
    document.body.style.overflow = '';
  }
  cartOpenBtns.forEach(btn => btn.addEventListener('click', openCart));
  cartCloseBtns.forEach(btn => btn.addEventListener('click', closeCart));
  if (cartOverlay) cartOverlay.addEventListener('click', closeCart);

  /* ============================================
     MOBILE MENU
     ============================================ */
  const mobileMenu = document.getElementById('mobile-menu');
  const mobileOverlay = document.getElementById('mobile-overlay');
  const mobileMenuBtn = document.getElementById('mobile-menu-btn');
  const mobileCloseBtns = document.querySelectorAll('[data-mobile-close]');

  function openMobile() {
    if (mobileMenu) mobileMenu.classList.add('active');
    if (mobileOverlay) mobileOverlay.classList.add('active');
    document.body.style.overflow = 'hidden';
  }
  function closeMobile() {
    if (mobileMenu) mobileMenu.classList.remove('active');
    if (mobileOverlay) mobileOverlay.classList.remove('active');
    document.body.style.overflow = '';
  }
  if (mobileMenuBtn) mobileMenuBtn.addEventListener('click', openMobile);
  mobileCloseBtns.forEach(btn => btn.addEventListener('click', closeMobile));
  if (mobileOverlay) mobileOverlay.addEventListener('click', closeMobile);

  /* Mobile submenu toggles */
  document.querySelectorAll('[data-mobile-toggle]').forEach(toggle => {
    toggle.addEventListener('click', function () {
      const target = document.getElementById(this.dataset.mobileToggle);
      if (target) target.classList.toggle('active');
    });
  });

  /* ============================================
     QUANTITY SELECTORS
     ============================================ */
  document.querySelectorAll('[data-qty-selector]').forEach(selector => {
    const minus = selector.querySelector('[data-qty-minus]');
    const plus = selector.querySelector('[data-qty-plus]');
    const display = selector.querySelector('[data-qty-value]');
    const input = selector.querySelector('input[type="number"]');

    let qty = parseInt((input && input.value) || 1);

    function updateQty(val) {
      qty = Math.max(1, val);
      if (display) display.textContent = qty;
      if (input) input.value = qty;
    }
    if (minus) minus.addEventListener('click', () => updateQty(qty - 1));
    if (plus) plus.addEventListener('click', () => updateQty(qty + 1));
  });

  /* ============================================
     PRODUCT GALLERY THUMBNAILS
     ============================================ */
  const mainImage = document.getElementById('product-main-img');
  document.querySelectorAll('[data-thumb]').forEach(thumb => {
    thumb.addEventListener('click', function () {
      document.querySelectorAll('[data-thumb]').forEach(t => t.classList.remove('active'));
      this.classList.add('active');
      if (mainImage) {
        mainImage.src = this.dataset.thumb;
        mainImage.alt = this.alt || '';
      }
    });
  });

  /* ============================================
     PRODUCT TABS
     ============================================ */
  document.querySelectorAll('[data-tab]').forEach(btn => {
    btn.addEventListener('click', function () {
      const group = this.dataset.tabGroup;
      const target = this.dataset.tab;
      document.querySelectorAll(`[data-tab-group="${group}"] [data-tab]`).forEach(b => b.classList.remove('active'));
      document.querySelectorAll(`[data-tab-panel-group="${group}"] [data-tab-panel]`).forEach(p => p.classList.remove('active'));
      this.classList.add('active');
      const panel = document.querySelector(`[data-tab-panel="${target}"]`);
      if (panel) panel.classList.add('active');
    });
  });

  /* ============================================
     FAQ ACCORDION
     ============================================ */
  document.querySelectorAll('.faq-question').forEach(question => {
    question.addEventListener('click', function () {
      const item = this.closest('.faq-item');
      const isActive = item.classList.contains('active');
      document.querySelectorAll('.faq-item').forEach(i => i.classList.remove('active'));
      if (!isActive) item.classList.add('active');
    });
  });

  /* ============================================
     FILTER CHECKBOXES
     ============================================ */
  document.querySelectorAll('.filter-checkbox').forEach(cb => {
    cb.addEventListener('click', function () {
      this.classList.toggle('checked');
      const svg = this.querySelector('svg');
      if (svg) svg.style.display = this.classList.contains('checked') ? 'block' : 'none';
    });
  });

  /* ============================================
     SCROLL REVEAL
     ============================================ */
  const reveals = document.querySelectorAll('.reveal');
  if ('IntersectionObserver' in window) {
    const obs = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('visible');
          obs.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -50px 0px' });
    reveals.forEach(el => obs.observe(el));
  } else {
    reveals.forEach(el => el.classList.add('visible'));
  }

  /* ============================================
     STICKY HEADER SHRINK
     ============================================ */
  const header = document.querySelector('.site-header');
  window.addEventListener('scroll', () => {
    if (header) {
      header.style.borderBottomColor = window.scrollY > 10 ? 'rgba(255,255,255,0.05)' : '';
    }
  }, { passive: true });

  /* ============================================
     NOTIFICATION TOAST
     ============================================ */
  window.showToast = function (message, type = 'success') {
    const existing = document.querySelector('.toast-notification');
    if (existing) existing.remove();
    const toast = document.createElement('div');
    toast.className = 'toast-notification';
    toast.style.cssText = `
      position:fixed;bottom:24px;right:24px;z-index:999;
      background:${type === 'success' ? '#d42b2b' : '#1a1a1a'};
      color:#fff;padding:14px 24px;border-radius:4px;
      font-family:'Barlow Condensed',sans-serif;font-size:14px;
      font-weight:700;text-transform:uppercase;letter-spacing:0.08em;
      box-shadow:0 4px 24px rgba(0,0,0,0.4);
      transform:translateY(80px);opacity:0;transition:all 0.3s ease;
    `;
    toast.textContent = message;
    document.body.appendChild(toast);
    requestAnimationFrame(() => {
      toast.style.transform = 'translateY(0)';
      toast.style.opacity = '1';
    });
    setTimeout(() => {
      toast.style.transform = 'translateY(80px)';
      toast.style.opacity = '0';
      setTimeout(() => toast.remove(), 300);
    }, 3000);
  };

  /* ============================================
     ADD TO CART (Shopify AJAX API)
     ============================================ */
  document.querySelectorAll('[data-add-to-cart]').forEach(form => {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      const btn = this.querySelector('[data-add-to-cart-btn]');
      const originalText = btn ? btn.textContent : '';
      if (btn) {
        btn.textContent = 'Ajout en cours...';
        btn.disabled = true;
      }
      const formData = new FormData(this);
      fetch('/cart/add.js', { method: 'POST', body: formData })
        .then(r => r.json())
        .then(data => {
          if (btn) { btn.textContent = 'Ajouté !'; }
          window.showToast('Produit ajouté au panier');
          refreshCartDrawer();
          setTimeout(() => {
            if (btn) { btn.textContent = originalText; btn.disabled = false; }
            openCart();
          }, 1000);
        })
        .catch(() => {
          if (btn) { btn.textContent = originalText; btn.disabled = false; }
          window.showToast('Erreur - Veuillez réessayer', 'error');
        });
    });
  });

  function formatMoney(cents) {
    return (cents / 100).toFixed(2).replace('.', ',') + '\u00a0€';
  }

  function updateCartCount() {
    fetch('/cart.js')
      .then(r => r.json())
      .then(cart => {
        document.querySelectorAll('.cart-count').forEach(el => {
          el.textContent = cart.item_count;
          el.style.display = cart.item_count > 0 ? 'flex' : 'none';
        });
      });
  }
  updateCartCount();

  /* ============================================
     REFRESH CART DRAWER (contenu dynamique)
     Reconstruit le HTML du drawer via /cart.js
     sans rechargement de page.
     ============================================ */
  function refreshCartDrawer() {
    fetch('/cart.js')
      .then(r => r.json())
      .then(cart => {
        // Mettre à jour le compteur
        document.querySelectorAll('.cart-count').forEach(el => {
          el.textContent = cart.item_count;
          el.style.display = cart.item_count > 0 ? 'flex' : 'none';
        });

        // Mettre à jour le titre du drawer
        const drawerTitle = document.querySelector('.cart-drawer-title');
        if (drawerTitle) {
          drawerTitle.textContent = 'Mon Panier (' + cart.item_count + ')';
        }

        // Reconstruire les items
        const cartItems = document.querySelector('.cart-items');
        if (!cartItems) return;

        if (cart.item_count === 0) {
          cartItems.innerHTML = `
            <div class="cart-empty">
              <div class="cart-empty-icon"></div>
              <p style="margin-bottom:16px;">Votre panier est vide</p>
              <a href="/collections/all" class="btn btn-primary btn-sm" data-cart-close>Voir les produits</a>
            </div>
          `;
          // Ré-attacher l'event sur le nouveau btn data-cart-close
          cartItems.querySelectorAll('[data-cart-close]').forEach(btn => btn.addEventListener('click', closeCart));
        } else {
          let html = '';
          cart.items.forEach(item => {
            const variantTitle = (item.variant_title && item.variant_title !== 'Default Title')
              ? `<div style="font-size:12px;color:var(--gray);margin-bottom:4px;">${item.variant_title}</div>`
              : '';
            // Propriétés GLOBO (line item properties)
            let propertiesHtml = '';
            if (item.properties && Object.keys(item.properties).length > 0) {
              Object.entries(item.properties).forEach(([key, value]) => {
                if (value && !key.startsWith('_')) {
                  propertiesHtml += `<div style="font-size:11px;color:var(--gray);line-height:1.4;">${key}: <span style="color:var(--gray-light);">${value}</span></div>`;
                }
              });
            }
            const imgHtml = item.image
              ? `<img src="${item.image}" alt="${item.product_title}" loading="lazy" style="width:100%;height:100%;object-fit:cover;">`
              : '';
            html += `
              <div class="cart-item" data-cart-item-key="${item.key}">
                <div class="cart-item-image">${imgHtml}</div>
                <div style="flex:1;min-width:0;">
                  <div class="cart-item-title">${item.product_title}</div>
                  ${variantTitle}
                  ${propertiesHtml}
                  <div class="cart-item-price">${formatMoney(item.final_price)}</div>
                  <div class="cart-item-qty">
                    <button class="qty-btn" data-cart-change="${item.key}" data-qty="${item.quantity - 1}">−</button>
                    <span>${item.quantity}</span>
                    <button class="qty-btn" data-cart-change="${item.key}" data-qty="${item.quantity + 1}">+</button>
                    <button data-cart-remove="${item.key}" style="margin-left:auto;font-size:11px;color:var(--gray);font-family:var(--font-display);text-transform:uppercase;letter-spacing:0.08em;background:none;border:none;cursor:pointer;padding:0;">Retirer</button>
                  </div>
                </div>
              </div>
            `;
          });
          cartItems.innerHTML = html;
          // Ré-attacher les events sur les nouveaux boutons qty
          attachCartItemEvents();
        }

        // Mettre à jour le footer (total + boutons)
        let cartFooter = document.querySelector('.cart-footer');
        if (cart.item_count > 0) {
          if (!cartFooter) {
            cartFooter = document.createElement('div');
            cartFooter.className = 'cart-footer';
            cartDrawer.appendChild(cartFooter);
          }
          cartFooter.innerHTML = `
            <div class="cart-total">
              <span class="cart-total-label">Total</span>
              <span class="cart-total-price">${formatMoney(cart.total_price)}</span>
            </div>
            <p style="font-size:12px;color:var(--gray);margin-bottom:16px;text-align:center;">Livraison calculée à la commande</p>
            <a href="/cart" class="btn btn-outline btn-full" style="margin-bottom:10px;">Voir le panier</a>
            <a href="/checkout" class="btn btn-primary btn-full">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/></svg>
              Commander
            </a>
          `;
        } else if (cartFooter) {
          cartFooter.remove();
        }
      })
      .catch(err => console.error('Erreur refreshCartDrawer:', err));
  }

  function attachCartItemEvents() {
    // Boutons +/- dans le drawer
    document.querySelectorAll('[data-cart-change]').forEach(btn => {
      btn.addEventListener('click', function () {
        const key = this.dataset.cartChange;
        const qty = parseInt(this.dataset.qty);
        fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: key, quantity: Math.max(0, qty) })
        })
          .then(r => r.json())
          .then(() => refreshCartDrawer())
          .catch(() => window.showToast('Erreur', 'error'));
      });
    });
    // Boutons Retirer
    document.querySelectorAll('[data-cart-remove]').forEach(btn => {
      btn.addEventListener('click', function () {
        const key = this.dataset.cartRemove;
        fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: key, quantity: 0 })
        })
          .then(r => r.json())
          .then(() => refreshCartDrawer())
          .catch(() => window.showToast('Erreur', 'error'));
      });
    });
  }

  // Rafraîchir le drawer à l'ouverture (au cas où d'autres onglets/apps ont modifié le panier)
  cartOpenBtns.forEach(btn => btn.addEventListener('click', refreshCartDrawer));

  /* ============================================
     CATEGORIES DROPDOWN (button-controlled)
     ============================================ */
  const navCategories = document.getElementById('nav-categories');
  const dropdownTrigger = navCategories && navCategories.querySelector('.nav-dropdown-trigger');

  if (navCategories && dropdownTrigger) {
    // Open on hover (desktop UX)
    navCategories.addEventListener('mouseenter', function () {
      this.classList.add('dropdown-open');
      dropdownTrigger.setAttribute('aria-expanded', 'true');
    });
    navCategories.addEventListener('mouseleave', function () {
      this.classList.remove('dropdown-open');
      dropdownTrigger.setAttribute('aria-expanded', 'false');
    });
    // Toggle on click (keyboard / touch)
    dropdownTrigger.addEventListener('click', function (e) {
      e.stopPropagation();
      const isOpen = navCategories.classList.toggle('dropdown-open');
      this.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    });
    // Close on outside click
    document.addEventListener('click', function () {
      navCategories.classList.remove('dropdown-open');
      dropdownTrigger.setAttribute('aria-expanded', 'false');
    });
  }


  document.querySelectorAll('[data-newsletter-form]').forEach(form => {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      const input = this.querySelector('input[type="email"]');
      const btn = this.querySelector('button');
      if (btn) btn.textContent = 'OK !';
      window.showToast('Merci pour votre inscription !');
      if (input) input.value = '';
      setTimeout(() => {
        if (btn) btn.textContent = btn.dataset.original || 'OK';
      }, 3000);
    });
  });

});


/* ============================================
   GLOBO OPTIONS > SWATCHES BUTTONS (v4)
   - Swatches deplacees dans #globo-options-anchor
     (avant la quantite)
   - Container blanc GLOBO natif masque
   - MutationObserver sur document.body entier
   ============================================ */
(function () {

  var EXCLUDE = ['.sort-select', '[data-variant-select]', '#SingleOptionSelector'];

  function isExcluded(el) {
    return EXCLUDE.some(function (s) {
      try { return el.matches(s); } catch (e) { return false; }
    });
  }

  /* Trouve le container natif GLOBO le plus haut possible pour le masquer */
  function findGloboNativeContainer(select) {
    var el = select.parentElement;
    var last = el;
    /* Remonter jusqu'a tomber hors du form produit ou trouver un wrapper GLOBO explicite */
    while (el && el !== document.body) {
      var isGloboWrapper =
        (el.id && /globo|gpo/i.test(el.id)) ||
        (el.className && typeof el.className === 'string' && /globo|gpo|po__/i.test(el.className));
      if (isGloboWrapper) return el;
      /* Container avec fond blanc = le bloc entier GLOBO */
      var bg = window.getComputedStyle(el).backgroundColor;
      if (bg && bg !== 'rgba(0, 0, 0, 0)' && bg !== 'transparent' && bg !== 'rgb(17, 17, 17)' && bg !== 'rgb(26, 26, 26)' && bg !== 'rgb(34, 34, 34)') {
        return el;
      }
      last = el;
      el = el.parentElement;
    }
    return last;
  }

  /* Map : select -> wrapper swatch genere, pour pouvoir le deplacer */
  var createdWrappers = [];

  function convertSelect(select) {
    if (select.dataset.globoConverted === '1') return;
    if (isExcluded(select)) return;

    var inProductForm = select.closest('form[action="/cart/add"]') ||
                        select.closest('.product-info') ||
                        select.closest('[class*="globo"]') ||
                        select.closest('[class*="po__"]') ||
                        select.closest('[id*="globo"]') ||
                        select.closest('[id*="gpo"]');
    if (!inProductForm) return;

    select.dataset.globoConverted = '1';

    var options = Array.from(select.options);
    var hasPlaceholder = options.length > 0 && (
      options[0].value === '' ||
      options[0].value === '0' ||
      /veuillez|selectionner|choisir|select/i.test(options[0].text)
    );
    var choices = hasPlaceholder ? options.slice(1) : options;
    if (choices.length === 0) return;

    /* Trouver le label */
    var parent = select.parentElement;
    var labelEl = null;
    if (select.id) labelEl = document.querySelector('label[for="' + select.id + '"]');
    if (!labelEl && parent) labelEl = parent.querySelector('label');
    if (!labelEl && parent && parent.parentElement) labelEl = parent.parentElement.querySelector('label');
    if (!labelEl) {
      var prev = select.previousElementSibling;
      while (prev) {
        if (prev.tagName === 'LABEL') { labelEl = prev; break; }
        prev = prev.previousElementSibling;
      }
    }

    var rawLabel = labelEl ? labelEl.textContent.trim() : (select.name || '');
    var labelText = rawLabel
      .replace(/\s*\*\s*$/, '')
      .replace(/^(selectionner|veuillez selectionner|choisir)\s+/i, '')
      .trim()
      .replace(/^./, function (c) { return c.toUpperCase(); });

    /* Construire le wrapper swatch */
    var wrapper = document.createElement('div');
    wrapper.className = 'globo-swatch-wrapper';

    var labelDiv = document.createElement('div');
    labelDiv.className = 'product-option-label';
    var selectedSpan = document.createElement('span');
    selectedSpan.className = 'globo-swatch-selected';
    var initVal = (select.value && select.value !== '' && select.value !== '0')
      ? ' : ' + select.options[select.selectedIndex].text : '';
    selectedSpan.textContent = initVal;
    labelDiv.textContent = labelText;
    labelDiv.appendChild(selectedSpan);
    wrapper.appendChild(labelDiv);

    var grid = document.createElement('div');
    grid.className = 'option-swatches';

    choices.forEach(function (opt) {
      var btn = document.createElement('div');
      btn.className = 'option-swatch' + (select.value === opt.value ? ' active' : '');
      btn.textContent = opt.text;
      btn.addEventListener('click', function () {
        grid.querySelectorAll('.option-swatch').forEach(function (b) { b.classList.remove('active'); });
        btn.classList.add('active');
        selectedSpan.textContent = ' : ' + opt.text;
        select.value = opt.value;
        ['change', 'input'].forEach(function (ev) {
          select.dispatchEvent(new Event(ev, { bubbles: true }));
        });
      });
      grid.appendChild(btn);
    });

    wrapper.appendChild(grid);

    /* Masquer le select natif (le garder dans le DOM pour GLOBO) */
    select.style.cssText = 'position:absolute!important;opacity:0!important;pointer-events:none!important;width:1px!important;height:1px!important;overflow:hidden!important;';
    if (labelEl) labelEl.style.cssText = 'display:none!important;';

    /* Masquer le container blanc GLOBO natif */
    var nativeContainer = findGloboNativeContainer(select);
    if (nativeContainer && nativeContainer !== document.body) {
      nativeContainer.style.cssText = nativeContainer.style.cssText + ';display:none!important;';
    }

    createdWrappers.push(wrapper);
    /* Inserer temporairement dans le body pour ne pas perdre le node */
    document.body.appendChild(wrapper);
  }

  /* Deplace tous les wrappers generes dans l'ancre avant la quantite */
  function moveWrappersToAnchor() {
    var anchor = document.getElementById('globo-options-anchor');
    if (!anchor) return;
    createdWrappers.forEach(function (w) {
      if (w.parentNode !== anchor) {
        anchor.appendChild(w);
      }
    });
  }

  /* Masque le rectangle recapitulatif GLOBO (fond blanc avec les valeurs selectionnees)
     en cherchant tout element avec fond blanc/clair injecte dans la zone produit */
  function hideGloboSummary() {
    var productZone = document.querySelector('.product-info, #MainContent, main');
    if (!productZone) return;

    /* Classes exactes inspectees dans le navigateur */
    var knownSelectors = [
      '.gpo-group__childs',
      '.gpo-element',
      '.gpo-form__group',
      '[class*="gpo-group"]',
      '[class*="gpo-element"]',
      '[class*="gpo-form"]',
      '[class*="gpo-selected"]',
      '[class*="globo-selected"]',
      '[class*="po__selected"]',
      '[class*="selected-options"]',
      '[id*="gpo-selected"]',
      '[id*="globo-selected"]',
      '[class*="option-summary"]',
      '[class*="gpo-summary"]',
      '.gpo__selected-options',
      '.po__selected-options'
    ];
    knownSelectors.forEach(function (sel) {
      document.querySelectorAll(sel).forEach(function (el) {
        el.style.setProperty('display', 'none', 'important');
      });
    });

    /* Fallback : fond blanc sans inputs/buttons */
    var anchor = document.getElementById('globo-options-anchor');
    productZone.querySelectorAll('div, section').forEach(function (el) {
      if (anchor && anchor.contains(el)) return;
      if (el.closest('form[action="/cart/add"]')) return;
      if (el.closest('.cart-drawer, .toast, header, nav, footer')) return;
      if (el.id === 'globo-options-anchor') return;
      var bg = window.getComputedStyle(el).backgroundColor;
      if (bg === 'rgb(255, 255, 255)' || bg === 'rgba(255, 255, 255, 1)') {
        if (!el.querySelector('input, button, select, a, img')) {
          el.style.setProperty('display', 'none', 'important');
        }
      }
    });
  }

  function scanAndConvert() {
    var scope = document.querySelector('form[action="/cart/add"]') ||
                document.querySelector('.product-info') ||
                document.querySelector('#MainContent') ||
                document;
    scope.querySelectorAll('select').forEach(convertSelect);
    document.querySelectorAll(
      '[class*="globo"] select, [class*="po__"] select, [id*="globo"] select, [id*="gpo"] select, .gpo-form__group select, .gpo-element select, .gpo-group__childs select'
    ).forEach(convertSelect);
    moveWrappersToAnchor();
    hideGloboSummary();
  }

  var observer = new MutationObserver(function (mutations) {
    var needsScan = false;
    mutations.forEach(function (m) {
      m.addedNodes.forEach(function (n) {
        if (n.nodeType !== 1) return;
        if (n.tagName === 'SELECT' || (n.querySelector && n.querySelector('select'))) needsScan = true;
      });
    });
    if (needsScan) scanAndConvert();
  });

  observer.observe(document.body || document.documentElement, { childList: true, subtree: true });

  scanAndConvert();
  [100, 300, 600, 1000, 1500, 2500, 4000].forEach(function (d) {
    setTimeout(scanAndConvert, d);
  });

})();
